module.exports = __webpack_public_path__ + "static/manualMarca-859c7babc8b7b0406e0188b6c736ab3e.pdf";